import React, { useState } from "react";
import "./NumberToCall.scss";
import phoneIcon from "../../../../assets/icons/phone.svg";
import { toast, ToastContainer } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import uploadIcon from "../../../../assets/icons/upload.svg";
import { Link } from "react-router-dom";
import { flask_url } from "./../../../../Socket";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { isValidPhoneNumber } from "react-phone-number-input";

const NumberToCall = ({ promptType, agentData }) => {
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const handleClose = () => setShow(false);
  const handleClose2 = () => setShow2(false);
  const handleShow = () => setShow(true);
  const handleShow2 = () => setShow2(true);
  const [phone, setPhone] = useState("");
  const [phoneerror, setPhoneerror] = useState("");
  const [checkNumber, setCheckNumber] = useState(false);
  const [gender, setGender] = useState("1");
  const [userName, setUserName] = useState("");
  const handleGenderChange = (event) => {
    setGender(event.target.value);
    console.log("Selected Gender:", gender); // 1 for male, 2 for female
  };
  // console.log("Prompt Type :", promptType);
  // console.log("Phone Number :", phone);

  // drag state
  const [dragActive, setDragActive] = React.useState(false);
  const inputRef = React.useRef(null);

  // handle drag events
  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  // triggers when file is dropped
  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      // at least one file has been dropped so do something
      // handleFiles(e.dataTransfer.files);
    }
  };

  const handleChange = function (e) {
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      // at least one file has been selected so do something
      // handleFiles(e.target.files);
    }
  };

  const handlePhone = () => {
    if (!phone) {
      setPhoneerror("Number is required");
      return;
    }
    if (phone.length !== 11) {
      setPhoneerror("Phone number must be 11 digits");
    }
  };

  console.log(agentData, "Agent");
  const StartCall = async () => {
    // console.log(checkNumber,"Starting");
    const phoneTransfer = agentData?.Action?.transfer_call_number || "";

    console.log("transfer Calling Number " + phoneTransfer);
    if (!checkNumber) {
      setPhoneerror("Number is required");
      return;
    }

    try {
      const url = `${flask_url}/outboundcall_customAgent`;

      const requestBody = {
        number: phone,
        transfer_call_number: phoneTransfer,
        userName: userName,
        voice_id: gender,
        agent_id: agentData._id,
      };

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        toast.error("Sorry Something went wrong");
        throw new Error(`HTTP error! Status: ${response.status}`);
      } else {
        toast.success("Call Starting..");
      }
    } catch (error) {
      toast.error("Something went wrong");
      console.log(error);
    }
  };

  const [selectedOption, setSelectedOption] = useState("concrete");

  const handleRadioChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleInputChange = (value) => {
    console.log("Number :", value);

    setPhone(value);
    if (value && isValidPhoneNumber(value.toString()) != false) {
      setPhoneerror("");
      setCheckNumber(true);
    } else {
      // setPhoneerror("Invalid Number");
      setCheckNumber(false);
    }
  };

  // console.log("check Number", checkNumber);

  const radioStyle = {
    marginRight: "10px",
  };

  const labelStyle = {
    marginRight: "20px",
    fontSize: "16px",
    color: "#dcc25f",
   display:"flex",flexDirection:"row",
   justifyContent:"center",
   alignItems:"center",
    gap:"5px"
  };

  const radioInputStyle = {
    // position: 'absolute',
    // opacity: 0,
    cursor: 'pointer',
    height: 20,
    width: 20,
    color:"#dcc25f"
  };
  const handleName = (event) => {
    setUserName(event.target.value);
  };
  return (
    <div className="numberToCall-main-container">
      <h4>Add Number to call</h4>

      <div className="numberToCall-inner-container">
        {/* <label>Add phone number</label> */}
        <div>
          {/* <PhoneInput international countryCallingCodeEditable={false} defaultCountry="CA" autoComplete="off" /> */}
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <div style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
              <label>Name</label>
              <input type="text" value={userName} onChange={handleName} />
            </div>
            <PhoneInput
              international
              countryCallingCodeEditable={false}
              defaultCountry="CA"
              value={phone}
              onChange={handleInputChange}
              autoComplete="off"
            />
            {agentData?.Action?.transfer_call_number && (
              <PhoneInput
                international
                value={agentData?.Action?.transfer_call_number || ""}
                autoComplete="off"
              />
            )}
          </div>

          <div style={{display:"flex",flexDirection:"row" , margin:"15px"}}>
          <div style={{display:"flex",flexDirection:"row"}}>
          <label style={labelStyle}>
          <input
          type="radio"
          value="1"
          checked={gender === "1"}
          onChange={handleGenderChange}
          style={radioInputStyle}
          />
          Male
          </label>
          </div>
          <div style={{display:"flex",flexDirection:"row"}}>
          <label style={labelStyle}>
          <input
          type="radio"
          value="2"
          checked={gender === "2"}
          onChange={handleGenderChange}
          style={radioInputStyle}
          />
          Female
          </label>
          </div>
          </div>

          <p style={{fontSize:"20px", fontStyle:"normal", fontWeight:"bold"}}>Script : </p>
          {agentData &&
            agentData.agentScript.map((item, index) => (
              <>
                <p key={index}>{item}</p>
                {index < agentData.agentScript.length - 1 && (
                  <p className="wait">Please wait...</p>
                )}
              </>
            ))}
        </div>
        <span style={{ color: "red" }}>{phoneerror}</span>
        <span className="link-dail-calling">
          <button onClick={StartCall} disabled={!checkNumber}>
            <img src={phoneIcon} alt="" />
            Call
          </button>
        </span>
      </div>

      {/* <div className="uploaddiv"> */}
      {/* <button className="themebtn-1" onClick={handleShow2}>
          Or Upload an Excel Sheet
        </button> */}
      {/* <div className="dialer-radios-box mt-4">
          <label className="mr-3">
            <input type="radio" value="concrete" checked={selectedOption === "concrete"} onChange={handleRadioChange} onClick={handleShow2} />
            <span className="pl-1">CSV</span>
          </label>

          <label>
            <input type="radio" value="csv" checked={selectedOption === "csv"} onChange={handleRadioChange} />
            <span className="pl-1">Hub Spot</span>
          </label>
        </div>
      </div> */}

      <Modal
        show={show2}
        onHide={() => {
          handleClose2 && handleClose2();
        }}
        className="agentModal4"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="modalBody">
          <h4>Upload Document</h4>
          <p className="callRpara">Upload number’s document to call</p>
          <section id="form-file-upload">
            <input
              ref={inputRef}
              type="file"
              name="file"
              id="input-file-upload"
              multiple={true}
              onChange={handleChange}
              accept=".xlsx, .xls"
            />
            <label id="label-file-upload" htmlFor="input-file-upload">
              <div>
                <img className="mb-3" src={uploadIcon} alt="" />
                <p className="upload-text">
                  Click to upload files from computer
                </p>
                <p className="upload-text2">or drag and drop here</p>
                {/* <button className="upload-button" onClick={onButtonClick}>or drag and drop here</button> */}
                {/* <button className="upload-button">or drag and drop here</button> */}
              </div>
            </label>
            {dragActive && (
              <div
                id="drag-file-element"
                onDragEnter={handleDrag}
                onDragLeave={handleDrag}
                onDragOver={handleDrag}
                onDrop={handleDrop}
              ></div>
            )}
          </section>
        </Modal.Body>
        <Modal.Footer>
          <Link to="/aicall">
            <button
              onClick={() => {
                handleClose2 && handleClose2();
              }}
              className="callBtn"
            >
              Call
            </button>
          </Link>
        </Modal.Footer>
      </Modal>

      <ToastContainer />

      {/* {selectedOption === "csv" && (
        <div className="mr-4">
          <table class="contact-table mt-4 ">
            <thead>
              <tr>
                <th>Name</th>
                <th>Service</th>
                <th>Phone Number</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>John Doe</td>
                <td>Customer Support</td>
                <td>(555) 123-4567</td>
              </tr>
              <tr>
                <td>Jane Smith</td>
                <td>Sales</td>
                <td>(555) 987-6543</td>
              </tr>
              <tr>
                <td>John Doe</td>
                <td>Customer Support</td>
                <td>(555) 123-4567</td>
              </tr>
              <tr>
                <td>Jane Smith</td>
                <td>Sales</td>
                <td>(555) 987-6543</td>
              </tr>
              <tr>
                <td>John Doe</td>
                <td>Customer Support</td>
                <td>(555) 123-4567</td>
              </tr>
              <tr>
                <td>Jane Smith</td>
                <td>Sales</td>
                <td>(555) 987-6543</td>
              </tr>
              <tr>
                <td>John Doe</td>
                <td>Customer Support</td>
                <td>(555) 123-4567</td>
              </tr>
              <tr>
                <td>Jane Smith</td>
                <td>Sales</td>
                <td>(555) 987-6543</td>
              </tr>
              <tr>
                <td>John Doe</td>
                <td>Customer Support</td>
                <td>(555) 123-4567</td>
              </tr>
              <tr>
                <td>Jane Smith</td>
                <td>Sales</td>
                <td>(555) 987-6543</td>
              </tr>
            </tbody>
          </table>
        </div>
      )} */}
    </div>
  );
};

export default NumberToCall;
